<template>
  <div class="sign-up">
    <my-modal>
      <sign-up-step-data
        v-if="step === 'data'"
        @complete="completeStepData"
      />
      <sign-up-step-phone
        v-if="step === 'phone'"
        @complete="completeStepPhone"
        @back="returnToStart"
        @change-phone="handlePhoneChange"
        :phone="phone"
      />
      <sign-up-step-verification-fail
        v-if="step === 'verification-fail'"
      />
      <sign-up-step-document
        v-if="step === 'document'"
        :show-delayed-upload-message="showDelayedUploadMessage"
        @hide-delayed-upload-message="hideDelayedUploadMessage"
        @complete="completeStepDocument"
      />
      <sign-up-step-document-fail
        v-if="step === 'document-fail'"
      />
      <sign-up-step-email-confirm
        v-if="step === 'email-confirm'"
        :email="email"
        @change-email="handleEmailChange"
      />
      <sign-up-step-email-broken-link
        v-if="step === 'email-broken-link'"
        :calculated-step = "calculatedStep"
        @complete="completeStepEmailBrokenLink"
      />
      <sign-up-step-survey
        v-if="step === 'survey'"
        @complete="completeStepSurvey"
      />
      <sign-up-step-password
        v-if="step === 'password'"
        @complete="completeStepPassword"
      />
      <!--sign-up-step-policy
        v-if="step === 'policy'"
        @complete="completeStepPolicy"
      /-->
      <sign-up-step-success
        v-if="step === 'success'"
      />
      <sign-up-step-fail
        v-if="step === 'fail'"
      />

      <div v-if="step === 'deletion'">
        <div v-if="!deletionAgreed" class="form__description form__description_align-center">
          После удаления анкеты ваш аккаунт нельзя будет восстановить
        </div>
        <div v-else class="form__description form__description_align-center">
          Ваша анкета будет удалена {{deletionDate}}
        </div>
        <div v-if="!deletionAgreed">
          <div class="form__description form__description_align-center">
            <a href="#" class="form__link" @click.prevent="confirmDeletion">Удалить анкету</a>
          </div>
          <div class="form__description_align-center">
            <a href="#" class="form__link" @click.prevent="returnBack">Вернуться назад</a>
          </div>
        </div>
        <div v-else>
          <div class="form__description_align-center">
            <a href="#" class="form__link" @click.prevent="abortDeletion">Отменить удаление</a>
          </div>
        </div>
      </div>
    </my-modal>
  </div>
</template>

<script>
import MyModal from './MyModal';
import SignUpStepData from './SignUpStepData';
import SignUpStepPhone from './SignUpStepPhone';
import SignUpStepVerificationFail from './SignUpStepVerificationFail';
import SignUpStepDocument from './SignUpStepDocument';
import SignUpStepDocumentFail from './SignUpStepDocumentFail';
import SignUpStepEmailConfirm from './SignUpStepEmailConfirm';
import SignUpStepEmailBrokenLink from './SignUpStepEmailBrokenLink';
import SignUpStepSurvey from './SignUpStepSurvey';
import SignUpStepPassword from './SignUpStepPassword';
import SignUpStepPolicy from './SignUpStepPolicy';
import SignUpStepSuccess from './SignUpStepSuccess';
import SignUpStepFail from './SignUpStepFail';
import api from "../services/api";
import { parseQueryString, formatPhoneNumber } from "../utils";

export default {
  name: "SignUp",
  components: {
    MyModal,
    SignUpStepData,
    SignUpStepPhone,
    SignUpStepVerificationFail,
    SignUpStepDocument,
    SignUpStepDocumentFail,
    SignUpStepEmailConfirm,
    SignUpStepEmailBrokenLink,
    SignUpStepSurvey,
    SignUpStepPassword,
    SignUpStepPolicy,
    SignUpStepSuccess,
    SignUpStepFail,
  },
  props: {
    initStep: {type: String, default: () => 'data'}
  },
  data() {
    return {
      step: null,
      calculatedStep: null,
      email: '',
      memoStep: false,
      deletionAgreed: false,
      redirect: this.$attrs.redirect,
      phone: '',
      formData: null, // данные, полученные на шаге 1
      profileData: false,
      isDocumentStepDelayed: false, // перенесен ли шаг загрузки паспорта в конец регистрации
      showDelayedUploadMessage: false, // показать сообщение о необходимости повторной загрузки паспорта при отложенной загрузке
    };
  },
  async created() {
    const params = parseQueryString(window.location.search.substring(1));
    // сохраняем все query кроме direct-crm-ticket
    const url = new URL(window.location)
    url.searchParams.delete('direct-crm-ticket')
    history.replaceState({}, '', url.toString());

    if (typeof params['direct-crm-ticket'] !== 'undefined') {
      const profile = await this.emailTicketCheck(params);
      if (profile) { // авторизация по тикету успешна, переходим к текущему шагу
        this.profileData = profile;
        this.setProfileData();
        this.calculatedStep = await this.calculateStep();
        await this.applyCalculatedStep();
      } else {
        await this.getProfileData();
        this.calculatedStep = await this.calculateStep();
        /*
        для шагов, идущих до подтверждения email,
        показать сообщение о неправильной ссылке
        для остальных просто перейти на нужный шаг
         */
        switch(this.calculatedStep) {
          case 'data':
          case 'phone':
          case 'document':
          case 'email-confirm':
            this.step = 'email-broken-link';
            break;
          default:
            await this.applyCalculatedStep();
        }
      }
    } else {
      await this.calculateAndApplyStep();
    }

    /*
    нужно для случаев, если открыто несколько вкладок
    позволяет запросить профиль каждый раз,
    когда пользователь возвращается во вкладку
     */
    window.addEventListener('focus', this.handleWindowFocus.bind(this));
  },
  computed: {
    deletionDate() {
      let now = new Date();
      now.setDate(now.getDate() + 30);
      return now.toLocaleDateString();
    },
  },
  async mounted() {
    this.$root.$on('signUpDeletionStep', this.goToStepDeletion);
  },
  destroyed() {
    this.$root.$off('signUpDeletionStep', this.goToStepDeletion);
  },
  methods: {
    async completeStepData(idxResult, phone, email, formData) {
      this.email = email;
      this.phone = phone;
      this.formData = formData;

      const profile = await api.fetchProfile();
      const phoneIsVerified = profile.isMobilePhoneConfirmed;

      let nextStep;

      if (phoneIsVerified) {
        nextStep = await this.getPersonVerification();
      } else {
        nextStep = 'phone';
      }
      nextStep = 'phone';
      await this.setStep(nextStep);
    },
    async setStep(nextStep) {
      this.step = nextStep;
    },
    async completeStepPhone() {
      const nextStep = await this.getPersonVerification();
      await this.setStep(nextStep);
    },
    async completeStepEmailBrokenLink() {
      await this.setStep(this.calculatedStep);
    },
    async completeStepDocument(status) {
      let nextStep;
      const isDelayed = await api.getDelayedDocumentCheckInSession();

      if ((status === 'validated') && isDelayed) {
        // успешная отложенная загрузка, регистрация закончена
        nextStep = 'success';
      } else if ((status === 'validated') && !isDelayed) {
        // успешная загрузка с первой или второй попытки, продолжение регистрации
        nextStep = 'email-confirm';
      } else if ((status === 'suggested-delay') && isDelayed) {
        // предложено отложить загрузку, но она уже отложена, показать сообщение, затем вернуться к загрузке
        nextStep = 'document';
        this.showDelayedUploadMessage = true;
      } else if ((status === 'suggested-delay') && !isDelayed) {
        // предложено отложить загрузку, продолжение регистрации
        await api.setDelayedDocumentCheckInSession();
        nextStep = 'email-confirm';
      }

      await this.setStep(nextStep);
    },
    async getPersonVerification(successStep) {
      this.$store.dispatch("showLoader");
      // Отправляем запрос в IDX
      const personVerificationResult = await this.verifyPersonWithRetry(this.formData);
      this.$store.dispatch("hideLoader");

      let step;

      if (!personVerificationResult || personVerificationResult.status === "error") {
        step = 'verification-fail';
      } else if (personVerificationResult.data === false) {
        step = 'document';
      } else if (personVerificationResult.data === true) {
        // проверка документов не требуется, сохранить соответствующий флаг в сессию и перейти на следующий шаг
        await api.setSkipDocumentStepInSession();
        step = successStep || 'email-confirm';
      }

      return step;
    },
    async completeStepPassword() {
      let nextStep;
      // Проверяем, нужно ли дополнительно загружать документы
       nextStep = await api.getDelayedDocumentCheckInSession() ? 'document' : 'success';
      // Эти шаги нужно сохранить в сессию, так как их нельзя вычислить по профилю пользователя
      await api.setRegistrationStepInSession(nextStep);
      await this.setStep(nextStep);
    },
    async completeStepSurvey() {
      await this.setStep('password');
    },
    async completeStepPolicy() {
      await this.setStep('success');
    },
    async returnToStart() {
      this.memoStep = false;
      await this.setStep('data');
    },
    async goToStepDeletion() {
      this.memoStep = this.step;
      await this.setStep('deletion');
    },
    async confirmDeletion() {
      await this.$store.dispatch('deleteProfile');
      this.deletionAgreed = true;
    },
    async abortDeletion() {
      await this.$store.dispatch('deletionRecall');
      this.$store.commit('setDeletionStatus', null);
      this.deletionAgreed = false;
    },
    async returnBack() {
      await this.setStep(this.memoStep);
    },
    async emailTicketCheck(params) {
      try {
        // полноценная авторизация по тикету
        const result = await api.simplePostRequest('/api/ticketAuthorizationFull', {ticket: params['direct-crm-ticket']});
        return result.user;
      } catch (e) {
        return false;
      }
      /*
      if (result.needUpdatePersonalData) {
        return await this.$store.dispatch('goProfileForm');
      }
      */
      // await this.$store.dispatch('checkAuthentication');
      // await this.$store.dispatch('segmentsJump', result?.stepRegistration);
    },
    async verifyPersonWithRetry(profile) {
      const result = await api.verifyPersonNew(profile);
      if (result.status === 'error') {
        const filteredErrors = result.errors.filter(error => error.code !== 0); // Remove debug error with code 0
        const error = filteredErrors[0];
        if (error && error.code === 10) { // Timeout, try again
          await this.verifyPersonWithRetry(profile);
        } else { // Verification fail
          return result;
        }
      } else {
        return result;
      }
    },
    handlePhoneChange(phone) {
      this.phone = phone;
      this.formData.phone = phone;
    },
    handleEmailChange(email) {
      this.email = email;
      this.formData.email = email;
    },
    async calculateAndApplyStep() {
      // await this.$store.dispatch('showLoader');
      await this.getProfileData();
      this.calculatedStep = await this.calculateStep();
      await this.applyCalculatedStep()
      // await this.$store.dispatch('hideLoader');
    },
    async getProfileData() {
      this.profileData = await api.fetchProfile();
      this.setProfileData();
    },
    async applyCalculatedStep() {
      await this.setStep(this.calculatedStep);
    },
    setProfileData() {
      if (this.profileData) {
        this.phone = formatPhoneNumber(this.profileData.mobilePhone);
        this.email = this.profileData.email;
        this.formData = {
          'firstName': this.profileData.firstName,
          'middleName': this.profileData.middleName,
          'lastName': this.profileData.lastName,
          'birthDate': this.profileData.birthDate,
          'phone': this.phone,
          'email': this.email
        };
      }
    },
    handleWindowFocus() {
      switch (this.step) {
        case 'password':
        case 'success':
        case 'fail':
          return;
      }
      this.calculateAndApplyStep();
    },
    /*
    при регистрации после каждого шага в профиль пользователя добавляются какие-то параметры
    определяем текущий шаг через параметры, которые в данный момент содержатся в профиле пользователя
    это нужно для того, чтобы синхронизировать шаги регистрации в разных браузерах или на разных устройствах
    хранение шагов в сессии не позволяет этого сделать, так как сессия привязана к браузеру
    */
    async calculateStep() {
      const profile = this.profileData;
      if (profile === false) {
        return 'data'
      } else if (profile.isMobilePhoneConfirmed === false) {
        return 'phone'
      } else if (profile.isEmailConfirmed === false) {
        if (profile.customFields.idxVerifyPassportStatus !== true) {
          /*
          если не пройден шаг подтверждения email и не пройден шаг загрузки паспорта

          если ранее было предложено пропустить шаг загрузки паспорта
          (метод verifyPersonNew вернул в ответе data: true),
          переходим к шагу подтверждения email
          */
          if (await api.getSkipDocumentStepInSession()) {
            return 'email-confirm';
          }
          /*
          если ранее шаг загрузки паспорта уже проходился и было предложено повторить его в конце регистрации,
          переходим к шагу подтверждения email
          если флаги пропущенной и отложенной загрузки паспорта не заданы, переходим к шагу загрузки паспорта
          */
          return await api.getDelayedDocumentCheckInSession() ? 'email-confirm' : 'document';
        }
        return 'email-confirm'
      } else if (profile.customFields.primarySubfamily === undefined) {
        return 'survey'
      } else {
        /*
        если все параметры, перечисленные выше, заданы, значит сейчас либо шаг установки пароля,
        либо те шаги и экраны, которые могут быть после него:
        - шаг повторной загрузки документов
        - экран успешной регистрации
        эти этапы нельзя вычислить по параметрам в профиле пользователя
        поэтому их берем из сессии
        */
        const stepFromSession = await api.getRegistrationStepInSession();
        if (!stepFromSession) {
          return 'password';
        } else {
          return stepFromSession;
        }
      }
    },
    hideDelayedUploadMessage() {
      this.showDelayedUploadMessage = false;
    }
  }
}
</script>

<style lang="scss">
@import "../scss/base/_settings.scss";
.sign-up {
  min-height: 100%;

  .form__description {
    max-width: 456px;

    @include mobile {
      max-width: 100%;
    }
  }

  .my-modal__content {
    max-width: 657px;
  }

  .form__title {
    margin-bottom: 8px;
  }

  &-terms {
    &__title {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
    }
    &__subtitle {
      font-size: 14px;
      font-weight: bold;
    }
    &__subheading {
      font-size: 12px;
      font-weight: bold;
      font-style: italic;
      line-height: 1.2;
    }
    &__text {
      font-size: 12px;
      line-height: 1.2;
      margin-top: 16px;
    }
    ul {
      padding-left: 21px;
    }
    li {
      font-size: 12px;
      line-height: 1.2;
      margin: 10px 0;
    }
    &__first-line {
      display: block;
      font-weight: bold;
    }
    &__footnotes {
      margin-top: 1em;
      padding-top: 8px;
      border-top: 1px solid $brand-color;
    }
    &__footnote {
      font-size: 10px;
      line-height: 1.2;
    }
  }
}
.mx-datepicker-popup {
  z-index: 9999;
}
</style>
